const difference = (atom) => {
    const observe = (callback) => {
        let prev;
        const selector = (value) => {
            const p = prev;
            prev = value;
            return { previous: p, current: value };
        };
        return atom.observe((value) => callback(selector(value)));
    };
    return {
        ...atom,
        observe,
    };
};
export default difference;
